import { Banner } from '../store/schema/Banner';
import { getStore } from '../store/appModuleStore';
import { mutatorAction } from 'satcheljs';

export const setShownBanner = mutatorAction('setShownBanner', (banner: Banner) => {
    const store = getStore();
    store.shownBanner = banner;
});
